import Vue from 'vue';
import VueAnalytics from 'vue-ua';
import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';
import VueResource from 'vue-resource';
import App from './App';
import EventBusPlugin from '@/plugins/EventBusPlugin';
import MobileDetectPlugin from '@/plugins/MobileDetectPlugin';
import StorePlugin from '@/plugins/StorePlugin';
import ResidenceInteractive from '@/components/ResidenceInteractive';
import MobileInteractive from '@/components/MobileInteractive';


Vue.config.productionTip = false;


Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(EventBusPlugin);
Vue.use(MobileDetectPlugin);
Vue.use(StorePlugin);


let mdInit = new MobileDetectPlugin.MobileDetect(window.navigator.userAgent);


const routes = [{
    name:       'home',
    path:       '/',
    component:  (mdInit.phone()) ? MobileInteractive : ResidenceInteractive
}];


export const router = new VueRouter({
    mode: 'history',
    routes: routes,
    base: '/'
});


Vue.use(VueAnalytics, {
    appName:            'MBRe|Residential',
    appVersion:         'v1.0.0',
    trackingId:         'XXXXXXXXXXXXX',
    debug:              false,
    vueRouter:          router,
    ignoredViews:       [],
    globalDimensions:   [],
    globalMetrics:      []
});


const app = new Vue({
    router: router,
    render: h => h(App)
}).$mount('#app');

sync(app.$dataStore, router);



// WEBPACK FOOTER //
// ./src/main.js